var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['end_bt', _vm.isfixed&&'fixed_bt']},[_c('div',{class:['end_bt_content', _vm.disable&&'disable_bt'],on:{"click":_vm.clickHandle}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }